import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/showToaster';
import { updateWhyHost4 } from '../../../../lib/graphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

   const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;
  
  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: updateWhyHost4,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateWhyHostPage?.status === 200) {
    showToaster({ messageId: 'updateHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateHostPageError', toasterType: 'error' })
  }

}

export default submit;
